import React from 'react'
import { Grid } from '@mui/material'
import Typography from '@mui/material/Typography'
import LanguageStrings from '../../../../i18n/locales'

const customKpi = LanguageStrings().ThermalIQStrings.CreateCustomKpiComponent

interface ParameterFormViewProps {
  stageParameter: any
  isAssetLevel: boolean
  fieldKey?: string
  operator?: string
}

const ParameterFormView: React.FC<ParameterFormViewProps> = ({
  stageParameter,
  isAssetLevel,
  fieldKey,
  operator
}) => {
  const commonStyles = {
    color: '#F0F0F0',
    fontFeatureSettings: "'clig' off, 'liga' off",
    fontFamily: '"Honeywell Sans Web"',
    fontSize: '16px',
    fontStyle: 'normal',
    lineHeight: '24px',
    letterSpacing: '0.5px'
  }
  return (
    <div style={{ width: '318px', gap: '0px', borderRadius: '5px', background: '#202020', flexShrink: '0', padding: '10px' }}>
      {(isAssetLevel && stageParameter?.is_device_id === true) &&
        (
          <Grid item style={{ marginBottom: '10px' }}>
            <Typography style={{ ...commonStyles, fontWeight: 500 }}>
              {stageParameter?.asset_id === stageParameter?.device_id ? 'Asset' : 'Device'}
            </Typography>
            <Typography style={{ ...commonStyles, fontWeight: 600 }}>
              {stageParameter?.device_name}
            </Typography>
          </Grid>
        )
      }
      {
        stageParameter?.is_device_id === true
          ? (
              <Grid item>
                <Typography style={{ ...commonStyles, fontWeight: 500 }}>
                  {fieldKey === 'parameter1' && operator === 'TOTALIZER' ? 'Condition Parameter to Totalize' : fieldKey === 'parameter2' && operator === 'TOTALIZER' ? 'Variable to Totalize' : customKpi.Parameter}
                </Typography>
                <Typography style={{ ...commonStyles, fontWeight: 600 }}>{stageParameter?.parameter_name}</Typography>
              </Grid>
            )
          : (
            <Grid item style={{ marginBottom: '30px' }}>
              <Typography style={{ ...commonStyles, fontWeight: 500 }}>{customKpi.Constant}</Typography>
              <Typography style={{ ...commonStyles, fontWeight: 600 }}>{stageParameter?.constant_value}</Typography>
            </Grid>
            )
      }
    </div>
  )
}

export default ParameterFormView
